import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  createReplacement({ commit, state, rootState }, payload) {
    return axios.post('/api/replacements', payload)
  },
}
